module.exports = __webpack_public_path__ + "static/extra_3-f558fa0ed2973a3178c128775bf003d8.jpg";